import { ModalEffect } from '../../../types/modal.mjs';
import Heading from '../../Typography/Heading/Heading.mjs';
import IconButtonComponent from '../IconButton/IconButton.mjs';
import styled, { css } from 'styled-components';

const scaleFadeEffect = css `
  transition-property: transform, opacity;
  transition-duration: ${({ theme }) => theme.animation.duration.gentle1};
  transition-timing-function: ${({ isModalShown, theme }) => isModalShown
    ? theme.animation.easing.expressive.entrance
    : theme.animation.easing.expressive.exit};
  transform: scale(${({ isModalShown }) => Number(isModalShown)});
  opacity: ${({ isModalShown }) => Number(isModalShown)};
`;
const EffectsMap = {
    [ModalEffect.SCALE_FADE]: scaleFadeEffect
};
const StyledWrapper = styled.div `
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${props => props.theme.zIndex.modal};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ enableOverlay, theme }) => enableOverlay ? `${theme.colors.slate}80` : 'transparent'};
`;
const StyledContainer = styled.div `
  position: relative;
  max-height: 100vh;
  width: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  padding: 3.5rem 1.5rem;
  background-color: ${props => props.theme.colors.backgroundColor};
  box-sizing: border-box;

  ${({ effect }) => EffectsMap[effect]};

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    padding: 3.5rem 4rem;
  }
`;
const StyledModalCloseButton = styled(IconButtonComponent) `
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;

  svg {
    width: 16px;
    height: 16px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    svg {
      width: auto;
      height: auto;
    }
  }
`;
const StyledHeading = styled(Heading) `
  max-width: 396px;
  text-align: center;
  margin: 0;
  font-size: ${props => props.theme.typography.headings.h3.fontSize};
  line-height: ${props => props.theme.typography.headings.h3.lineHeight};

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.typography.headings.h2.fontSize};
    line-height: ${props => props.theme.typography.headings.h2.lineHeight};
  }
`;

export { StyledContainer, StyledHeading, StyledModalCloseButton, StyledWrapper };
//# sourceMappingURL=Modal.styles.mjs.map
